import cx from 'classnames'
import React from 'react'

import * as styles from './list.module.css'

const List: React.FC<{ className?: string }> = ({ className = '', children }) => (
  <div role="list" className={cx(styles.list, className)}>
    {children}
  </div>
)

export default List
